<template>
  <div>
    <button type="button" class="btn btn-info flex-item" @click="handleAccept">
      <em class="fa fa-check"/>
      Accept
    </button>
  </div>
</template>

<script>
import DesignAssignForm from "@/components/Views/Design/DesignAssignForm";
import Modal from "@/components/Misc/Modal";
import embApi from "@/store/api/emb";

export default {
  name: "DesignAcceptButton",
  components: {Modal, DesignAssignForm},
  props: {value: Object},
  data() {
    return {
      loading: true
    }
  },
  methods: {
    async handleAccept() {
      this.loading = true
      const api = embApi(this.$store.dispatch)
      const {data} = await api.acceptDesign(this.value.id)
      this.$emit('success', data)
      this.loading = false
    }
  }
}
</script>